/* ============================================================
   Ecrilo — bandeau d'annonces : rotation + épinglage au défilement.

   DEUX COMPORTEMENTS, UNE SEULE RÈGLE : ne jamais faire sauter la page.

   1. Rotation. Une annonce à la fois, fondu et léger glissement. Arrêtée au
      survol, au focus clavier, quand l'onglet passe en arrière-plan, et jamais
      démarrée si le visiteur demande moins d'animations.

   2. Épinglage. Tant que le haut de page est visible, le bandeau reste dans le
      flux, au-dessus de l'en-tête. Dès que l'en-tête est sorti par le haut, le
      bandeau vient se coller en haut de l'écran ; il repart quand on remonte,
      et l'en-tête reprend sa place.

      La détection passe par une sentinelle observée, jamais par un écouteur de
      scroll : un `scroll` se déclenche des dizaines de fois par seconde et fait
      du travail de mise en page à chaque fois. Une hystérésis (deux seuils
      différents selon le sens) évite le clignotement quand on s'arrête pile à
      la limite.

      Le bandeau épinglé quitte le flux : une cale de même hauteur prend sa
      place, sinon la page remonterait d'un cran au moment exact où l'on défile.
   ============================================================ */
(function () {
  "use strict";
  var doc = document;
  var bandeau = doc.querySelector("[data-ec-annonce]");
  if (!bandeau) return;

  var sentinelle = bandeau.querySelector("[data-ec-annonce-sentinelle]");
  var cale = doc.querySelector("[data-ec-annonce-cale]");
  var items = [].slice.call(bandeau.querySelectorAll("[data-ec-annonce-item]"));
  var reduit = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ── 1. Rotation ─────────────────────────────────────────── */
  if (items.length > 1 && !reduit) {
    var i = 0, minuteur = null, gele = false;
    var duree = parseFloat(getComputedStyle(bandeau).getPropertyValue("--ec-annonce-duree")) || 4;

    function montrer(n) {
      items.forEach(function (el, k) {
        var actif = k === n;
        el.classList.toggle("is-actif", actif);
        el.classList.toggle("is-sortant", k === i && !actif);
      });
      i = n;
    }
    function tourner() { if (!gele) montrer((i + 1) % items.length); }
    function demarrer() { arreter(); minuteur = setInterval(tourner, duree * 1000); }
    function arreter() { if (minuteur) { clearInterval(minuteur); minuteur = null; } }

    bandeau.addEventListener("mouseenter", function () { gele = true; });
    bandeau.addEventListener("mouseleave", function () { gele = false; });
    bandeau.addEventListener("focusin", function () { gele = true; });
    bandeau.addEventListener("focusout", function () { gele = false; });
    // Un onglet en arrière-plan n'a personne pour le lire : on économise le travail.
    doc.addEventListener("visibilitychange", function () {
      if (doc.hidden) arreter(); else demarrer();
    });
    demarrer();
  }

  /* ── 2. Épinglage ────────────────────────────────────────── */
  if (!sentinelle || !cale || !("IntersectionObserver" in window)) return;

  var epingle = false;

  function epingler(on) {
    if (on === epingle) return;
    epingle = on;
    if (on) {
      // La cale prend la hauteur RÉELLE mesurée avant le détachement.
      var h = bandeau.offsetHeight;
      cale.style.height = h + "px";
      // Et l en-tete collant doit descendre d autant, sinon les deux occupent
      // la meme bande : le bandeau est en z-index 60, l en-tete en 40, et le
      // texte du bandeau se peint par-dessus le logo.
      doc.documentElement.style.setProperty("--ec-annonce-h", h + "px");
      cale.hidden = false;
      bandeau.classList.add("is-epingle");
    } else {
      bandeau.classList.remove("is-epingle");
      cale.hidden = true;
      cale.style.height = "";
      doc.documentElement.style.removeProperty("--ec-annonce-h");
    }
    doc.documentElement.classList.toggle("ec-annonce-epinglee", on);
  }

  // Deux seuils : on épingle quand la sentinelle est sortie d'au moins la
  // hauteur de l'en-tête, on désépingle dès qu'elle revient. Sans cet écart,
  // s'arrêter pile à la limite ferait clignoter le bandeau.
  var marge = 120;
  try {
    var entete = doc.querySelector(".ec-header");
    if (entete && entete.offsetHeight) marge = entete.offsetHeight;
  } catch (e) {}

  var obs = new IntersectionObserver(function (entrees) {
    entrees.forEach(function (e) { epingler(!e.isIntersecting); });
  }, { rootMargin: "-" + marge + "px 0px 0px 0px", threshold: 0 });

  obs.observe(sentinelle);
})();
